export default [
    {
        path: '/user/country-proficiency',
        props: true,
        component: () => import('@/views/User/CountryProficiency'),
    }
];
